import { FieldUsageId } from '@sonar-software/sonar-core';
import React from 'react';
import { Tag } from 'antd';

const fieldUsageColors: Record<number, string> = {
	[ FieldUsageId.Active ]: 'green',
	[ FieldUsageId.DeprecateCandidate ]: 'volcano'
};

export interface FieldUsageTagProps {
	fieldUsageId: number | undefined;
}

export const FieldUsageTag: React.FC<FieldUsageTagProps> = ({ fieldUsageId = FieldUsageId.None }) => {
	const label = FieldUsageId[ fieldUsageId ];
	const color = fieldUsageColors[ fieldUsageId ];

	return fieldUsageId === FieldUsageId.None ? label : <Tag color={ color }>{ label }</Tag>;
};
